<template>
  <div class="cart">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">購物籃</a>
        <div>
          <button
            type="button"
            class="btn btn-primary addCarButton mr-3"
            @click="clearShoppingCart()"
          >
            清空購物車
          </button>
          <button
            type="button"
            class="btn btn-primary addCarButton"
            @click="goToAlibabaOrder()"
          >
            回上一頁
          </button>
        </div>
      </nav>

      <div class="title">訂單詳情</div>
      <ul class="list-group">
        <div v-if="displayViews == null || displayViews == undefined">
          <li class="list-group-item">
            <p class="noProd">您目前沒有加入商品到購物車喔!</p>
          </li>
        </div>
        <div v-else>
          <li
            class="list-group-item"
            v-for="(displayView, index) in displayViews"
            v-bind:key="(displayView, index)"
          >
            <div class="media">
              <img
                v-bind:src="displayView.color_image_selected"
                class="mr-3"
                width="120"
                height="120"
                referrerpolicy="no-referrer"
              />
              <div class="media-body" style="text-align: left">
                <div class="prod-block">
                  <h5 class="mt-0 prod-text">{{ displayView.prod_name }}</h5>
                </div>
                <div v-if="displayView.color_name_selected != undefined">
                  <p>
                    選擇的顏色:
                    <b>{{ displayView.color_name_selected }}</b>
                  </p>
                </div>

                <div
                  v-for="(sku_info, index) in displayView.sku_info"
                  v-bind:key="(sku_info, index)"
                >
                  <div v-if="sku_info != undefined && sku_info.amount > 0">
                    <p>
                      選擇的款式:
                      <b>{{ sku_info.sku_name }}</b>
                    </p>
                    <p>
                      數量:
                      <b>{{ sku_info.amount }}</b>
                    </p>
                  </div>
                </div>
                <p>
                  商品注意細節:
                  <b>{{ displayView.prod_detail }}</b>
                </p>
              </div>
              <div v-if="checkMobile == '0'">
                <br />
                <a
                  href="#"
                  class="btn btn-danger btn btn-sm"
                  style
                  @click="removeProd(index)"
                  >忍心刪除</a
                >
              </div>
            </div>

            <div v-if="checkMobile == '1'">
              <br />
              <a
                href="#"
                class="btn btn-danger btn btn-block"
                style
                @click="removeProd(index)"
                >忍心刪除</a
              >
            </div>
          </li>
        </div>
      </ul>

      <br />
      <div v-if="displayViews.length > 0">
        <button class="btn btn-danger btn-lg btn-block" @click="buy()">
          繼續完成委託單
        </button>
      </div>
      <div v-else>
        <button
          class="btn btn-danger btn-lg btn-block"
          @click="goToAlibabaOrder()"
        >
          回上一頁
        </button>
      </div>
      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { isMobile } from 'mobile-device-detect'
export default {
  name: 'cart',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      displayViews: null,
      isLoading: true,
      amounts: [],
      mapInfo: null,
      checkMobile: isMobile ? '1' : '0',
      buyBaseLine: 1,
    }
  },
  methods: {
    buy: function () {
      const vm = this

      let count = 0
      vm.displayViews.forEach(function (prodInfo) {
        vm.buyBaseLine = prodInfo.buy_base_line

        if (prodInfo.sku_info.length > 0) {
          prodInfo.sku_info.forEach(element => {
            count = parseInt(count) + parseInt(element.amount)
          })
          console.log(prodInfo.buy_base_line + ' ' + count)
        }
      })

      //
      if (count == 0) {
        vm.$toast.open({
          message: '請輸入數量!',
          type: 'error',
        })
      } else if (vm.$store.state.ignoreBaseLine === false) {
        if (count < vm.buyBaseLine) {
          vm.$toast.open({
            message: '注意低於起批數量' + vm.buyBaseLine + '個',
            type: 'error',
          })
        } else {
          vm.$router.push('profile')
        }
      } else {
        vm.$router.push('profile')
      }
    },
    removeProd: function (index) {
      const vm = this

      vm.displayViews.splice(index, 1)
      vm.$store.prodInfos = vm.displayViews
      localStorage.setItem('prodInfos', JSON.stringify(vm.displayViews))
      vm.$forceUpdate()
    },
    clearShoppingCart: function () {
      const vm = this
      vm.displayViews = []
      vm.$store.prodInfos = []
      localStorage.setItem('prodInfos', JSON.stringify([]))
      vm.$forceUpdate()
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (
        localStorage.userId == undefined ||
        localStorage.userImage == undefined ||
        localStorage.userName == undefined
      ) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        return true
      } else {
        return false
      }
    },
    goToAlibabaOrder: function () {
      const vm = this
      vm.$router.push('alibabaorder')
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    // Event snippet for 進入機器人購物車頁面 conversion page
    vm.$ga.event('event', 'conversion', {
      send_to: 'AW-700538278/aKz7CJu94rIBEKa7hc4C',
      value: 1.0,
      currency: 'TWD',
    })

    vm.checkUnChatbotSignin()

    if (vm.$store.prodInfos != undefined) {
      vm.displayViews = vm.$store.prodInfos
      vm.isLoading = false
    } else if (JSON.parse(localStorage.getItem('prodInfos')) != undefined) {
      vm.displayViews = JSON.parse(localStorage.getItem('prodInfos'))
      vm.isLoading = false
    }

    if (vm.displayViews == undefined) {
      vm.$modal.show('dialog', {
        title: '🙋請聯絡客服',
        text: '請聯絡客服⚡ 系統異常!',
        buttons: [
          {
            title: '👉聯絡客服',
            handler: () => {
              window.location = 'https://m.me/2266831083395361'
            },
          },
        ],
      })
    }
  },
}
</script>
